<template>
  <div class="spinner-grow mx-auto text-secondary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</template>
<script>
export default {
  name: "Loading",
};
</script>
